import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
const baseUrl = '  https://drghis.mgmebuild.com/api/';

const PatLabDetails = (props) => {
  const pat_id = localStorage.getItem('pat_id');

  const [rows, setRows] = useState([]);
  const [rows1, setRows1] = useState([]);
  const [patientData, setPatientData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response1 = await axios.get(`${baseUrl}pat-search-view/${pat_id}/`);
        if (response1.status === 200 || response1.status === 201) {
          setPatientData(response1.data);
          const patId = response1.data[0].id;
          const response2 = await axios.get(`${baseUrl}pat-emr-lab-op/${patId}/`);
          const labData = response2.data.map((data) => ({ ...data, type: 'lab' }));
          const response6 = await axios.get(`${baseUrl}pat-fetch-ip-status/${patId}/`);
          const ipData = response6.data.map((data) => ({
              id: data.id,
              ip_id: data.ip_id,
              pat__pat_id: data.pat.pat_id,
              pat__patient: data.pat.patient,
              pat__age: data.pat.age,
              pat__mobile: data.pat.mobile,
              pat__address1: data.pat.address1,
              room_no__room_no: data.room_no.room_no,
              payment: data.payment,
              admit_date: data.admit_date,
              discharge_time: data.discharge_time,
              action: '',
              summary: '',
            }));
            setRows1(ipData);
          const combined = [...labData];
          setRows(combined);
        } else {
          window.location.href = '/pat-menu/';
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [pat_id]);


  const columns = [
    { field: 'add_date', headerName: 'Appt Date', width: 120 },
    { field: 'appt_id', headerName: 'Appt Id', width: 200 },
    {
      field: 'test_name',
      headerName: 'Test Name',
      width: 600,
      valueGetter: (params) => {
        const data = params.row;
        return data.type === 'lab' ? data.lab_test : '';
      },
    },
    { field: 'addedby', headerName: 'Added by', width: 100 },
    {
    field: 'action',
    headerName: 'Action',
    renderCell: (params) => (
      <Link
        to={`/pat-lab-report-all/${params.row.appt_id}/`}
        className="btn btn-success"
      >
        Lab
      </Link>
    ),
    width: 100,
  },
  ];

      const columns1 = [
      {
        field: 'ip_id',
        headerName: 'IP ID',
        renderCell: (params) => (
          <Link to={`/ip-pat-view/${params.row.id}/`}>{params.value}</Link>
        ),
        width: 100,
      },
      { field: 'pat__pat_id', headerName: 'Pat Id', width: 40 },
      { field: 'pat__patient', headerName: 'Patient', width: 150 },
      { field: 'pat__age', headerName: 'Age', width: 50 },
      { field: 'pat__mobile', headerName: 'Mobile', width: 120 },
      { field: 'pat__address1', headerName: 'Address', width: 220 },
      { field: 'room_no__room_no', headerName: 'Room No', width: 75 },
      { field: 'payment', headerName: 'Payment', width: 100 },
      { field: 'admit_date', headerName: 'Admitted On', width: 120 },
      { field: 'discharge_time', headerName: 'Discharged On', width: 120 },
      {
        field: 'summary',
        headerName: 'Summary',
        renderCell: (params) => (
          <Link to={`/pat-discharge-summary/${params.row.id}/`} className="btn btn-warning">
            Summary
          </Link>
        ),
        width: 100,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
    ];


  return (
    <section className="container mt-4">
      <div className="row table-responsive">
        <div className="col-md-12 col-12 mb-2">
          <table className="erp-table-modern">
            <thead>
              <tr style={{ backgroundColor: '#1bc5ce', color: 'white' }}>
                <th>Patient ID</th>
                <th>Patient Name</th>
                <th>Gender</th>
                <th>D.O.B/Age</th>
                <th>Mobile</th>
                <th>Regd. On</th>
              </tr>
            </thead>
            <tbody>
              {patientData.map((patientData, index) => (
                <tr key={index}>
                  <td>{patientData.pat_id}</td>
                  <td>{patientData.patient}</td>
                  <td>{patientData.gender}</td>
                  <td>{patientData.age}</td>
                  <td>{patientData.mobile}</td>
                  <td>{patientData.add_date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        </div>
          <div style={{ height: '100%', width: '100%' }}>
          <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
            aria-hidden="true" style={{color: 'red'}}></i> OP Lab Results</h3>
            <DataGrid
              className="mt-4"
              sx={{
                boxShadow: 4,
                border: 4,
                borderColor: 'primary.light',
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
              }}
              rows={rows}
              columns={columns}
              pageSize={10}
              slots={{ toolbar: GridToolbar }}
              autoHeight
            />
          </div>
          <div style={{ height: '100%', width: '100%' }}>
          <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
            aria-hidden="true" style={{color: 'red'}}></i> IP Lab Results</h3>
            <DataGrid
              className="mt-4"
              sx={{
                boxShadow: 4,
                border: 4,
                borderColor: 'primary.light',
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
              }}
              rows={rows1}
              columns={columns1}
              pageSize={10}
              slots={{ toolbar: GridToolbar }}
              autoHeight
            />
          </div>
    </section>
  );
};

export default PatLabDetails;
